import { IState } from "../../interfaces";

export const StateEmpty: IState = {
    id: "",
    name: "",
    abbreviation: "",
    hasSubstate: false,
    country: "",
    _ts: 0,
  };